import { NgModule } from '@angular/core';
import { NeoDatepickerV2Module } from '@neogov/pattern-library/neo-datepicker-v2';
import { NeoAvatarModule } from '@neogov/pattern-library/neo-avatar';
import { NeoBadgeModule } from '@neogov/pattern-library/neo-badge';
import { NeoBadgeV2Module } from '@neogov/pattern-library/neo-badge-v2';
import { NeoButtonDropdownModule } from '@neogov/pattern-library/neo-button-dropdown';
import { NeoButtonV2Module } from '@neogov/pattern-library/neo-button-v2';
import { NeoChartModule } from '@neogov/pattern-library/neo-chart';
import { NeoGridV2Module } from '@neogov/pattern-library/neo-grid-v2';
import { NeoTableModule } from '@neogov/pattern-library/neo-table';
import { NeoLoaderWrapperModule } from '@neogov/pattern-library/neo-loader-wrapper';
import { NeoPopoverModule } from '@neogov/pattern-library/neo-popover';
import { NeoSingleSelectModule } from '@neogov/pattern-library/neo-single-select';
import { NeoSkipToContentModule } from '@neogov/pattern-library/neo-skip-to-content';
import { NeoTooltipModule } from '@neogov/pattern-library/neo-tooltip';
import { NeoTooltipV2Module } from '@neogov/pattern-library/neo-tooltip-v2';
import { NeoChipsModule } from '@neogov/pattern-library/neo-chips';
import { NeoModalModule } from '@neogov/pattern-library/neo-modal';
import { NeoFormElementsModule } from '@neogov/pattern-library/form-elements';
import { NeoFormFieldModule } from '@neogov/pattern-library/neo-form-field';
import { NeoInputModule } from '@neogov/pattern-library/neo-input';
import { NeoFlyoutModule } from '@neogov/pattern-library/neo-flyout';
import { NeoFlyoutV2Module } from '@neogov/pattern-library/neo-flyout-v2';
import { NeoRequiredLabelModule } from '@neogov/pattern-library/neo-required-label';
import { NeoDialogModule } from '@neogov/pattern-library/neo-dialog';
import { NeoSelectModule } from '@neogov/pattern-library/neo-select';
import { NeoCheckboxV2Module } from '@neogov/pattern-library/neo-checkbox-v2';
import { NeoInputSearchModule } from '@neogov/pattern-library/neo-input-search';
import { NeoCardModule } from '@neogov/pattern-library/neo-card';
import { NeoMenuModule } from '@neogov/pattern-library/neo-menu';
import { NeoInfoboxModule } from '@neogov/pattern-library/neo-infobox';
import { NeoInfoboxV2Module } from '@neogov/pattern-library/neo-infobox-v2';
import { NeoExpansionModule } from '@neogov/pattern-library/neo-expansion-panel';
import { NeoVerticalNavModule } from '@neogov/pattern-library/neo-vertical-nav';
import { NeoButtonModule } from '@neogov/pattern-library/neo-button';
import { NeoStepperModule } from '@neogov/pattern-library/neo-stepper';
import { NeoAutocompleteV2Module } from '@neogov/pattern-library/neo-autocomplete-v2';
import { NeoTabsModule } from '@neogov/pattern-library/neo-tabs';
import { NeoButtonToggleModule } from '@neogov/pattern-library/neo-button-toggle';
import { NeoSortModule } from '@neogov/pattern-library/neo-sort';
import { NeoPaginatorModule } from '@neogov/pattern-library/neo-paginator';
import {
  NeoTableButtonComponent,
  NeoTableMultiSelectFilterComponent,
  NeoTableSingleSelectFilterComponent
} from '@neogov/pattern-library/neo-table-filter';
import {
  NeoBatchActionsLeftDirective,
  NeoBatchActionsRightDirective,
  NeoBatchActionsToolbarComponent
} from '@neogov/pattern-library/neo-batch-actions-toolbar';
import { NeoSlideToggleModule } from '@neogov/pattern-library/neo-slide-toggle';
import { NeoIconModule } from '@neogov/pattern-library/neo-icon';

@NgModule({
  imports: [
    NeoDatepickerV2Module,
    NeoAvatarModule,
    NeoBadgeModule,
    NeoBadgeV2Module,
    NeoButtonDropdownModule,
    NeoButtonV2Module,
    NeoButtonModule,
    NeoButtonToggleModule,
    NeoChartModule,
    NeoFlyoutModule,
    NeoFlyoutV2Module,
    NeoGridV2Module,
    NeoTableModule,
    NeoLoaderWrapperModule,
    NeoPopoverModule,
    NeoSkipToContentModule,
    NeoSingleSelectModule,
    NeoTooltipModule,
    NeoTooltipV2Module,
    NeoChipsModule,
    NeoModalModule,
    NeoFormElementsModule,
    NeoFormFieldModule,
    NeoInputModule,
    NeoInputSearchModule,
    NeoDialogModule,
    NeoRequiredLabelModule,
    NeoSelectModule,
    NeoCheckboxV2Module,
    NeoCardModule,
    NeoMenuModule,
    NeoInfoboxModule,
    NeoInfoboxV2Module,
    NeoExpansionModule,
    NeoVerticalNavModule,
    NeoStepperModule,
    NeoAutocompleteV2Module,
    NeoTabsModule,
    NeoSortModule,
    NeoPaginatorModule,
    NeoTableButtonComponent,
    NeoTableMultiSelectFilterComponent,
    NeoTableSingleSelectFilterComponent,
    NeoBatchActionsToolbarComponent,
    NeoBatchActionsLeftDirective,
    NeoBatchActionsRightDirective,
    NeoSlideToggleModule,
    NeoIconModule
  ],
  exports: [
    NeoDatepickerV2Module,
    NeoAvatarModule,
    NeoBadgeModule,
    NeoBadgeV2Module,
    NeoButtonDropdownModule,
    NeoButtonV2Module,
    NeoButtonModule,
    NeoButtonToggleModule,
    NeoChartModule,
    NeoFlyoutModule,
    NeoFlyoutV2Module,
    NeoGridV2Module,
    NeoTableModule,
    NeoLoaderWrapperModule,
    NeoPopoverModule,
    NeoSkipToContentModule,
    NeoSingleSelectModule,
    NeoTooltipModule,
    NeoTooltipV2Module,
    NeoChipsModule,
    NeoModalModule,
    NeoFormElementsModule,
    NeoFormFieldModule,
    NeoInputModule,
    NeoInputSearchModule,
    NeoDialogModule,
    NeoRequiredLabelModule,
    NeoSelectModule,
    NeoCheckboxV2Module,
    NeoCardModule,
    NeoMenuModule,
    NeoInfoboxModule,
    NeoInfoboxV2Module,
    NeoExpansionModule,
    NeoVerticalNavModule,
    NeoStepperModule,
    NeoAutocompleteV2Module,
    NeoTabsModule,
    NeoSortModule,
    NeoPaginatorModule,
    NeoTableButtonComponent,
    NeoTableMultiSelectFilterComponent,
    NeoTableSingleSelectFilterComponent,
    NeoBatchActionsToolbarComponent,
    NeoBatchActionsLeftDirective,
    NeoBatchActionsRightDirective,
    NeoSlideToggleModule,
    NeoIconModule
  ]
})
export class PatternLibraryModule {}
